import * as React from 'react';
import { memo } from 'react';

const SvgUserCircle = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M9.318 15.478a6.3 6.3 0 1 0 0-12.6 6.3 6.3 0 0 0 0 12.6Z", stroke: "currentColor", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M9.318 11.278a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25Z", stroke: "currentColor", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M5.105 13.864a4.725 4.725 0 0 1 8.427 0", stroke: "currentColor", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgUserCircle);

export { Memo as default };
